import Vue from 'vue';
import { ModalService } from '@app/plugins/iview-modal-modify/service';
import i18n from '@app/plugins/i18n';
import { CampaignsService } from '@autoinformer/services/CampaignsService';
import { WorksheetsService } from '@autoinformer/services/WorksheetsService';
import CreateSchemeForm from '@autoinformer/components/create-scheme-form';

class CampaignsModalService extends ModalService {
  constructor() {
    super(CampaignsService);
  }

  create({ scheme_type }) {
    return this.$open({
      title: i18n.t('autoinformer.campaign.modal.create_scheme.title'),
      width: this.size.confirm,
      render: (h) => {
        return h(CreateSchemeForm, {
          props: {
            scheme_type
          },

          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        });
      }
    });
  }

  remove(id, item) {
    return this.$confirm({
      loading: true,
      title: i18n.t('shared.component.modal.confirm'),
      content: i18n.t('autoinformer.campaign.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      }),
      onOk: () => {
        CampaignsService.deleteItem(id)
          .then(() => {
            this.$emit('success');
            this.modal.remove();
          })
          .catch((e) => {
            this.$emit('fail');
            this.modal.setLoading(false);
            Vue.noty.server_error(e);
          })
          .finally(() => {
            this.$emit('finally');
          });
      },
      onCancel: () => this.$emit('finally')
    });
  }

  change_status(state, id) {
    const state_key = state ? 'enable' : 'disable';
    const content = i18n.t(`autoinformer.campaign.modal.change_status.${state_key}`);
    return this.$confirm({
      loading: true,
      title: i18n.t('shared.component.modal.confirm'),
      content,
      onOk: () => {
        CampaignsService.editItem(id, { active: state })
          .then(() => {
            this.$emit('success');
            this.modal.remove();
          })
          .catch((e) => {
            this.$emit('fail');
            this.modal.setLoading(false);
            Vue.noty.server_error(e);
          })
          .finally(() => {
            this.$emit('finally');
          });
      },
      onCancel: () => this.$emit('finally')
    });
  }

  notice_pbx_module_required() {
    return this.$confirm({
      title: i18n.t('shared.component.modal.warning'),
      content: i18n.t(`autoinformer.campaign.modal.notice_pbx_module_required.content`),
      okText: i18n.t(`autoinformer.campaign.modal.notice_pbx_module_required.ok`),
      onOk: () => this.$emit('success'),
      onCancel: () => this.$emit('finally')
    });
  }

  deleteScheme(id) {

    return this.$confirm({
      loading: true,
      title: i18n.t('shared.component.modal.confirm'),
      content: i18n.t(`autoinformer.campaign.modal.delete_scheme`),
      onOk: () => {
        WorksheetsService.deleteScheme(id)
          .then(() => {
            this.$emit('success');
            this.modal.remove();
          })
          .catch((e) => {
            this.$emit('fail');
            this.modal.setLoading(false);
            Vue.noty.server_error(e);
          })
          .finally(() => {
            this.$emit('finally');
          });
      },
      onCancel: () => this.$emit('finally')
    });
  }
}

const instance = new CampaignsModalService();
export { instance as CampaignsModalService };
